import announcement from './announcement';
import document from './document';

export default {
    announcement,
    document,
};
